<template>
    <div class="vs-row" v-if="load.name=='Итоговая аттестация'">
        <div class="vx-row my-4" v-for="(item, i) in controlFormsData" :key="i + 'cf'">
            <div class="vx-col w-full">
                <vx-card class="px-4 vs-con-loading__container" >
                    <div class="flex flex-wrap">
                        <vs-checkbox
                            v-for="checkbox in item.select"
                            v-model="selected[checkbox.uid]"
                            class="my-2"
                            :value="checkbox.uid"
                            :key="checkbox.uid"
                            :disabled="true">
                            {{ checkbox.name }}
                        </vs-checkbox>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ControlForms",
    props:{
        controlFormsData:Array,
        selected:Array,
    }
};
</script>

<style scoped>

</style>
